// Backend URL resolution.
//
// Strategy:
//   - In the browser, we check whether the app is being served from a cloud
//     host (preview.emergentagent.com / emergent.host / tailorflow.tech /
//     emergentcf.cloud). If yes → use same-origin (empty string) so axios
//     calls hit `/api/*` on the current host. The platform ingress routes
//     these to the backend container automatically, which avoids every CORS
//     and cross-environment headache.
//   - On localhost / 127.0.0.1 (dev) we fall back to the build-time env var
//     REACT_APP_BACKEND_URL so hot-reload dev still works.
//
// Why not always use the env var?
//   The env var is BAKED IN at build time. If the frontend is built on the
//   preview environment and then deployed to a different host (emergent.host
//   or a custom domain), the hardcoded preview URL causes a cross-origin
//   request from the deployed host back to preview — which breaks CORS and
//   causes the browser to throw "Network Error" on every /api/* call.
const _envUrl = (process.env.REACT_APP_BACKEND_URL || '').trim();

function resolveBackendUrl() {
  if (typeof window === 'undefined') return _envUrl;
  const host = window.location.hostname;
  const isLocalDev = host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0';
  // Any non-local host → use same-origin. Covers preview, emergent.host,
  // emergentcf.cloud, tailorflow.tech, and any future custom domain.
  if (!isLocalDev) return '';
  return _envUrl;
}

export const BACKEND_URL = resolveBackendUrl();
